import { z } from 'zod';
/** Room ceiling is 8 players (D-ROOMS), so indexes run 0..7. */
export const MAX_PLAYERS = 8;
export const MAX_ACTIONS_PER_FRAME = 32;
export const vec3Schema = z.tuple([z.number(), z.number(), z.number()]);
export const insetsSchema = z.looseObject({
    top: z.number(),
    right: z.number(),
    bottom: z.number(),
    left: z.number(),
});
export const actionValueSchema = z.union([z.boolean(), z.number(), z.looseObject({ x: z.number(), y: z.number() })]);
export const actionFrameSchema = z.looseObject({
    playerIndex: z
        .number()
        .int()
        .min(0)
        .max(MAX_PLAYERS - 1),
    tick: z.number().int().min(0),
    source: z.enum(['keyboard', 'pointer', 'touch', 'gamepad', 'network']),
    actions: z
        .record(z.string().min(1).max(32), actionValueSchema)
        .refine((actions) => Object.keys(actions).length <= MAX_ACTIONS_PER_FRAME, {
        message: `at most ${MAX_ACTIONS_PER_FRAME} actions per frame`,
    }),
});
export const viewIdSchema = z.enum(['iso', 'topdown', 'side', 'follow', 'fps', 'orbit', 'fixed']);
/** Data half of a rig, so a manifest can declare overrides later. */
export const rigInputMappingSchema = z.looseObject({
    keyboard: z.record(z.string(), z.string()),
    touch: z.enum(['stick', 'two-stick', 'tap']),
    gamepad: z.record(z.string(), z.string()),
    pointerLock: z.boolean(),
});
export const inputSchemas = {
    'input.v1': actionFrameSchema,
};
//# sourceMappingURL=input.js.map